export default __webpack_public_path__ + "static/media/277.82f0d6f6.jpg";